import { render, staticRenderFns } from "./FBArticle.vue?vue&type=template&id=647e5510&"
import script from "./FBArticle.vue?vue&type=script&lang=js&"
export * from "./FBArticle.vue?vue&type=script&lang=js&"
import style0 from "./FBArticle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports